import React, { useCallback } from 'react';
import SearchDate from './SearchDate';
import SearchModule from './SearchModule';
import DeleteEventLog from './DeleteEventLog';

import './EventLogDetailSearchBar.css';

const EventLogDetailSearchBar = ({ setData, searchMap, setSearchMap, warningLogIdxs}) => {

  const updateSearchMap = useCallback((key, value) => {
    setSearchMap(searchMap => {
      return {
        ...searchMap,
        [key]: value
      }
    })
  }, [searchMap])

  return (
    <div className="searchBar-conatiner">
      <div className="form-row">
        <SearchDate searchMap={searchMap} updateSearchMap={updateSearchMap}/>
        <SearchModule updateSearchMap={updateSearchMap} />
        <DeleteEventLog setData={setData} warningLogIdxs={warningLogIdxs} />
      </div>
    </div>
  )
}

export default React.memo(EventLogDetailSearchBar);